import { Avatar, Stack, Typography } from '@mui/material';

interface ILogoButton {
  text: string;
  logo: string;
  href: string | undefined;
  ariaLabel: string;
}

export const LogoButton = ({ text, logo, href, ariaLabel }: ILogoButton) => {
  return (
    <Stack
      component='a'
      href={href}
      direction='column'
      alignItems='center'
      sx={{
        cursor: 'pointer',
        textDecoration: 'none',
      }}
      aria-label={ariaLabel}
    >
      <Avatar alt='' src={logo} sx={{ width: '33px' }} />
      <Typography color='white' whiteSpace='nowrap' variant='body3'>
        {text}
      </Typography>
    </Stack>
  );
};
